import { useTranslation } from 'react-i18next';

import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';
import { PharmacyCard } from '@phx/myphx-lib';

import { PharmacyChangeModal } from '../../cabinet/provider-offers/PharmacyChangeModal';

type ChooseDifferentPharmacyCardProps = {
    drxId: string;
};

export const ChooseDifferentPharmacyCard = ({
    drxId,
}: ChooseDifferentPharmacyCardProps) => {
    const [opened, { toggle }] = useDisclosure();
    const { t } = useTranslation();

    return (
        <>
            <PharmacyCard
                title={t('fill.selectPharmacy.chooseDifferent.title')}
                description={[
                    t('fill.selectPharmacy.chooseDifferent.description'),
                ]}
                onClick={toggle}
            />

            <PharmacyChangeModal
                drxId={drxId}
                isOpen={opened}
                toggle={toggle}
            />
        </>
    );
};
